<template>
  <div class="content_page_card">
      <div class="header">
        <div class="t">
          {{ props.title }}
          <span class="desc" v-if="props.desc">（{{ props.desc }}）</span>
        </div>
        <div class="operator">
          <el-button type="primary" @click="$emit('add')">{{ buttonLabel || '新增' }}</el-button>
        </div>
      </div>
      <slot></slot>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: 'Banner区域'
  },
  desc: {
    type: String,
  },
  isShowSearch: {
    type: Boolean,
    default: true
  },
  buttonLabel: {
    type: String,
  },
})

onMounted(() => {
})

</script>

<style lang='scss' scoped>
.content_page_card {
  padding: 28px;
  box-shadow: 0px 2px 10px 0px rgba(173, 173, 173, 0.3);
  border-radius: 12px;
  background: #FFFFFF;

  & + & {
    margin-top: 24px;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .t {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 550;
      color: #343840;
      line-height: 25px;
  }

  .operator {

  }

  .desc {
    font-size: 14px;
    color: #999;
    font-weight: normal;
  }

  .operate {
      padding-top: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 24px;
  }
}
</style>
